module.exports = __webpack_public_path__ + "img/candle_bg.96f7751b.png";